// React
import React from 'react';
// External libraries
import {
    Col, Container, Image, Row
} from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
// Internal
import FormNumber from 'components/auth/FormVerifyMobileNumber';
import config from 'config/config';
import BrandService from 'services/brand';
// Styles
import './styles.scss';
// Images
import paw from 'assets/images/paw.png';

class EngravingLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imgSrc: ''
        };
        this.getBrandImage();
    }

    /**
     * Gets the brand logo to display in the app
     */
    getBrandImage() {
        BrandService.getBrand()
            .then((response) => {
                this.setState({ imgSrc: response.data.brand_logo_link });
            }).catch((err) => {
                console.error(err);
            });
    }

    render() {
        return (
            <Container fluid className="login-page-wrapper">
                <Row className="login-page">
                    <Col className="left-section" md="auto" />
                    <Col className="right-section">
                        <div className="login-form-wrapper">
                            <div className="logo-wrapper">
                                <Image
                                    alt={config.webTitle}
                                    src={this.state.imgSrc}
                                    className="login-logo"
                                    height="40"
                                />
                            </div>

                            <div className="heading-wrapper">
                                <h1 className="page-heading">Engraving Approval</h1>
                                <p className="inline-block-below-lg">
                                    Please enter your mobile number to verify your identity and proceed.
                                </p>
                            </div>

                            <div className="form-wrapper">
                                <FormNumber
                                    bookingId={this.props.match.params.bookingId}
                                    quotedProductId={this.props.match.params.quotedProductId}
                                />
                            </div>
                            <Image alt="Pet paw" src={paw} className="image-paw" />
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(EngravingLogin);
